import React from 'react';
import { Link } from 'react-router-dom';
import './legal-pages.css';

export default function LegalDocumentLayout({ title, effectiveDate, card = false, children }) {
  const loggedIn = typeof localStorage !== 'undefined' && !!localStorage.getItem('token');

  return (
    <div className="legal-page">
      <div className={`legal-page__inner${card ? ' legal-page__inner--card' : ''}`}>
        <div className="legal-page__wordmark">Sovrynn</div>
        <div className="legal-page__speed-lines" aria-hidden>
          <div className="legal-page__speed-line" />
          <div className="legal-page__speed-line legal-page__speed-line--short" />
        </div>

        <h1 className="legal-page__title">{title}</h1>
        {effectiveDate ? (
          <p className="legal-page__effective">Effective Date: {effectiveDate}</p>
        ) : null}
        <hr className="legal-page__divider" />

        <div className="legal-page__content">{children}</div>

        <footer className="legal-page__footer">
          <p>
            Questions? Contact us at{' '}
            <a href="mailto:support@sovrynn.co">support@sovrynn.co</a>
          </p>
          <Link to={loggedIn ? '/dashboard' : '/'} className="legal-page__back">
            ← Back to Sovrynn
          </Link>
        </footer>
      </div>
    </div>
  );
}
